/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component } from '@angular/core';
import { NbLoginComponent } from '@nebular/auth';

@Component({
  selector: 'ngx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent extends NbLoginComponent {

  img = "../../../../assets/images/ictfax-logo.png";

  isLockedOut: boolean = false;
  maxFailedAttempts: number;
  lockoutMessage: string = '';
  error_message: string = '';
  userLock: string = '';

  
  login() {
    if (this.isLockedOut) {
      return;
    }
  
    this.errors = [];
    this.messages = [];
    this.submitted = true;
  
    this.service.authenticate(this.strategy, this.user).subscribe(
      (result) => {
        this.submitted = false;
        if (result.isSuccess()) {
          this.showMessages.success = true;
          this.messages = [result.getMessages().join(', ')];
          this.router.navigate(['/']);
        } else {
          this.attempts(result.getResponse().status);
          this.errors = result.getErrors();
          this.showMessages.error = true;
        }
      },
      (error) => {
        this.submitted = false;
        this.attempts(error.status);
        this.errors = [error.message];
        this.showMessages.error = true;
      }
    );
  }
  
  attempts(statusCode: number) {
    if (statusCode === 426) {
      this.error_message = "Your password has expired. Please reset you password";
      this.isLockedOut = false; 
    } else if (statusCode === 423) {
      this.isLockedOut = true;
      this.lockoutMessage = "Login/Email combination is not correct. Your account has been locked because you have reached the maximum number of invalid sign-in attempts. Please contact to admin";
    } else if (statusCode === 429) {
      this.isLockedOut = true;
      this.userLock = "Your account is locked. Please contact to support.";
    }
  }
}
  